import { Component } from '@angular/core';
import { SpinnerService, HelperService } from './core/services/index.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public spinner: SpinnerService, public helperService: HelperService) 
  {
    console.log("Application Start..!!");
  }
}
